import { ModuleAdminPage } from "./ModuleAdminPage";
export function AdminNewbiePage() { return <ModuleAdminPage title="新人成長" code="newbie" text="管理七關設定、補修、啟動筆與各關派發規則。" />; }
